/**
 * @desc Looks for the data-controller value in the html and loads the required JS modules
 * @param object controllers - List from App.js with all available controllers
 */
export class PageController
{
    constructor(controllers) {
        this.controllers = controllers;
        this.availableControllers = Object.keys(this.controllers);

        this._loadControllers(controllers);
    }

    _loadControllers() {
        let $controllers = $('[data-controller]');

        $.each($controllers, (i) => {
            let name = $controllers.eq(i).data('controller');

            // check if the controller is defined
            if (0 <= this.availableControllers.indexOf(name)) {
                const controller = this.controllers[name];
                new controller();
            }
        });
    }

}
